/**
 * Maker.
 *
 * @param {class} obj
 */
export function Maker(obj) {
  const className = obj.className()
  return controller => {
    $(className).each((inex, element) => {
      obj($(element), controller)
    })
  }
}

/**
 * ControllerBase  // コントローラー
 *
 * イベントの伝播やモデルの受渡しなど
 *
 * @returns {undefined}
 */
export default class ControllerBase {
  constructor(name) {
    this.name = name
    this.elements = {}
    this.objList = {}
    this.eventList = {}
  }

  /**
   * hook // オブジェクトをインスタンスにする
   *
   * @param {string} className // hookするjsのクラス名
   * @param {string} objectName // 登録されたobject名
   */
  hook(objectName, fragment = null) {
    const MyClassFunc = this.objList[objectName]
    // eventを初期化
    this.eventList[objectName] = []
    if (!fragment) fragment = $('html')
    if (MyClassFunc) MyClassFunc(this, fragment)
  }

  /**
   * hookAll.// viewModelの登録処理
   */
  hookAll() {
    Object.keys(this.objList).map(item => {
      this.hook(item)
    })
  }

  /**
   * hookAfterInit.// オーバーライド用
   */
  hookAfterInit() {}

  /**
   * hookCall // コントローラーのイベントを削除とclassインスタンスの登録
   *
   * @param {string} target // hookするjsのクラス名
   * @param {string} objectName // 登録されたobject名
   */
  hookCall(objectName, fragment = null) {
    this.off(objectName)
    this.hook(objectName, fragment)
  }

  /**
   * addObj // objectを登録する
   *
   * @param {class} MyClassObject // classオブジェクト
   */
  addObj(MyClassObject) {
    const objectName = MyClassObject.name()
    this.objList[objectName] = (controller, fragment) => {
      const className = MyClassObject.className()
      fragment.find(className).each((inex, element) => {
        return new MyClassObject($(element), controller)
      })
    }
  }

  /**
   * facade // インスタンスの登録処理
   */
  facade() {}

  /**
   * on // eventの登録
   *
   * @param {string} objectName // eventリストに登録するオブジェクトの名前
   * @param {string} eventName
   * @param {function} callback
   */
  on(objectName, eventName, callback) {
    const event = `custom:${this.name}:${eventName}`
    // eventリストに登録
    this.eventList[objectName].push(event)
    $(window).on(event, callback)
  }

  /**
   * off // オブジェクト名に紐づくeventの削除
   *
   * @param {string} objectName // オブジェクト名
   */
  off(objectName) {
    const events = $._data($(window).get(0), 'events')
    console.log(events)
    const eventList = this.eventList[objectName]
    if (!eventList) return
    eventList.map(eventName => {
      if (eventName in events) $(window).off(eventName)
    })
  }

  /**
   * action. // controllerのメソッドを実行
   *
   * @param {string} name
   * @param {any} data
   */
  action(name, data = null) {
    if (name === 'off') throw new Error('そいつはできない!!')
    const func = this[name]
    if (typeof func === 'function') return this[name](data)
    else throw new Error('関数がないよ')
  }

  /**
   * trigger // イベントのトリガー
   *
   * @param {string} eventName
   */
  trigger(eventName, data = null) {
    $(window).trigger(`custom:${this.name}:${eventName}`, data)
  }
}
